import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import {
    Container,
    Paper,
    Stack,
    Text,
    Title,
    Loader,
    Center,
    Badge
} from "@mantine/core";
import { getAuthHeaders } from "../../../api/authHelper";

type ParkingValidationDto = {
    isValid: boolean;
    eventId: number;
    personId: number;
    personName?: string;
    eventName?: string;
    note?: string;
};

export default function ParkingValidationPage() {
    const apiUrl = process.env.REACT_APP_API_URL;
    const { eventId, personId } = useParams();

    const [loading, setLoading] = useState(true);
    const [data, setData] = useState<ParkingValidationDto | null>(null);

    useEffect(() => {
        loadData();
    }, [eventId, personId]);

    async function loadData() {
        if (!apiUrl || !eventId || !personId) {
            setLoading(false);
            return;
        }

        setLoading(true);

        try {
            const res = await fetch(
                `${apiUrl}/api/parking/validate/${eventId}/${personId}`
                , {
                    headers: getAuthHeaders(),
                })

            const json = await res.json();
            setData(json);
        } catch {
            setData({
                isValid: false,
                eventId: Number(eventId),
                personId: Number(personId)
            });
        } finally {
            setLoading(false);
        }
    }

    const isValid = data?.isValid;

    return (
        <Container size="sm" py="xl">
            <Paper
                withBorder
                p="xl"
                radius="lg"
                style={{
                    backgroundColor: loading
                        ? "#f8f9fa"
                        : isValid
                            ? "#d3f9d8" // green
                            : "#ffe3e3" // red
                }}
            >
                {loading ? (
                    <Center>
                        <Stack align="center">
                            <Loader color="red" />
                            <Text>Checking parking access...</Text>
                        </Stack>
                    </Center>
                ) : isValid ? (
                    <Stack align="center" gap="md">
                        <Badge color="green" size="xl" variant="filled">
                            VALID
                        </Badge>

                        <Title order={2} ta="center">
                            VIP PARKING APPROVED
                        </Title>

                        <Text size="lg" fw={600}>
                            {data?.personName}
                        </Text>

                        <Text c="dimmed">
                            {data?.eventName}
                        </Text>

                        {data?.note && (
                            <Text ta="center">
                                {data.note}
                            </Text>
                        )}
                    </Stack>
                ) : (
                    <Stack align="center" gap="md">
                        <Badge color="red" size="xl" variant="filled">
                            DENIED
                        </Badge>

                        <Title order={2} ta="center">
                            ACCESS DENIED
                        </Title>

                        <Text ta="center" c="dimmed">
                            This person does not have VIP parking access.
                        </Text>
                    </Stack>
                )}
            </Paper>
        </Container>
    );
}